import { useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const UTMIFY_SRC = "https://cdn.utmify.com.br/scripts/utms/latest.js";
const UTMIFY_PIXEL_SRC = "https://cdn.utmify.com.br/scripts/pixel/pixel.js";

// Official UTMify "Código do Pixel": sets window.pixelId then loads pixel.js
const loadUtmifyPixel = (pixelId) => {
  const id = String(pixelId || "").trim();
  if (!/^[a-zA-Z0-9_-]{6,64}$/.test(id) || document.querySelector(`script[src="${UTMIFY_PIXEL_SRC}"]`)) return;
  window.pixelId = id;
  const s = document.createElement("script");
  s.src = UTMIFY_PIXEL_SRC;
  s.async = true;
  s.defer = true;
  (document.head || document.documentElement).appendChild(s);
};

// Official UTMify "Script de UTMs": captures utm_* / src / sck from the landing URL on every page
const loadUtmScript = () => {
  if (document.querySelector(`script[src="${UTMIFY_SRC}"]`)) return;
  const s = document.createElement("script");
  s.src = UTMIFY_SRC;
  s.setAttribute("data-utmify-prevent-xcod-sck", "");
  s.setAttribute("data-utmify-prevent-subids", "");
  s.async = true;
  s.defer = true;
  (document.head || document.documentElement).appendChild(s);
};

// Official UTMify "Script de Back Redirect": when the visitor presses Back, send them to `url` carrying the UTMs
const installBackRedirect = (rawUrl) => {
  let safeUrl = "";
  try {
    const parsed = new URL(rawUrl);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") safeUrl = parsed.toString();
  } catch {
    return;
  }
  if (!safeUrl || window.__msBackRedirect) return;
  window.__msBackRedirect = true;
  const urlBackRedirect = safeUrl.trim() + (safeUrl.indexOf("?") > 0 ? "&" : "?") + document.location.search.replace("?", "");
  window.history.pushState({}, "", window.location.href);
  window.history.pushState({}, "", window.location.href);
  window.history.pushState({}, "", window.location.href);
  window.addEventListener("popstate", () => {
    setTimeout(() => { window.location.href = urlBackRedirect; }, 1);
  });
};

const useUtmify = () => {
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    if (window.location.pathname.startsWith("/painel")) return;

    const ua = navigator.userAgent || "";
    const isInApp = /TikTok|Instagram|FBAN|FBAV|Twitter|Line|Snapchat|Kwai/i.test(ua);
    let timer;

    axios.get(`${API}/settings/site-info`, { timeout: 5000 })
      .then((res) => {
        const enabled = !!res.data?.utmify_enabled;
        const backRedirectUrl = res.data?.utmify_back_redirect_url;
        if (res.data?.utmify_pixel_id) loadUtmifyPixel(res.data.utmify_pixel_id);
        if (!enabled) return;
        loadUtmScript();
        // Back redirect breaks navigation inside in-app browsers; give the page time to settle elsewhere
        if (backRedirectUrl && !isInApp) {
          timer = setTimeout(() => installBackRedirect(backRedirectUrl), 3000);
        }
      })
      .catch(() => {});

    return () => clearTimeout(timer);
  }, []);
};

export default useUtmify;
